module.exports = __webpack_public_path__ + "img/Void.626369f0.png";